export class TotalOption {
  insertIndex: number; // 插入下标
  /** 合计值；hd-table 可不传，按 insertIndex 对应列对 content 自动求和 */
  insertValue?: any;
  align?: string; // 靠左还是靠右
  showDecimal?: boolean; // 是否显示小数位
  preserveNumber?: number; // 保留小数位数，不传默认 2
  isHide?: boolean; // 是否隐藏, 这里只针对列会同步消失的场景
}
